module.exports = __webpack_public_path__ + "static/media/Solution_Bottom_Decor@3x.68342a05.png";